
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/line-element",
      function () {
        return require("private-next-pages/x/api/charts/line-element.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/line-element"])
      });
    }
  